import React, { useEffect, useState } from "react";
import { callApi } from "../../api/callApi";
import AppData from "../../AppData";
import HeroBanner from "../../components/HeroBanner";

const Default = () => {
  const [stories, setStories] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    callApi({
      url: AppData.BASE_URL + "api/v1/cms/success_stories",
      method: "GET",
      callback: (result) => {
        if (
          result &&
          result.data &&
          result.data.data &&
          result.data.data.length > 0
        ) {
          setStories(result.data.data);
        }
      },
    });
  }, []);

  const renderStory = (story, key) => {
    return (
      <div className="success-story-card" key={key}>
        <div className="success-story-header">
          <div className="success-story-photo">
            <img
              src={
                story.attachment
                  ? AppData.BASE_URL + "upload/cms/" + story.attachment
                  : AppData.BASE_URL + "upload/no_image.jpg"
              }
              alt={story.title}
            />
          </div>
          <div className="success-story-name bold-text">{story.title}</div>
        </div>
        <div
          className="success-story-description description-text"
          style={{ textAlign: "justify" }}
          dangerouslySetInnerHTML={{ __html: story.description }}
        ></div>
      </div>
    );
  };

  return (
    <div>
      <HeroBanner name="Success Stories" />
      <div className="rest-page content-wrapper" style={{ minHeight: "30vh" }}>
        <div className="success-stories-container">
          {stories && stories.length > 0 ? (
            stories.map((story, key) => renderStory(story, key))
          ) : (
            <div className="description-text">No success stories yet.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Default;
